
import ImageZoom from './imageZoom';

var productImage = undefined;
var productImages = undefined;
var zoomImage = undefined;
let imageYOffset = undefined;
let firstHover = undefined;
let zoomPreview = undefined;

const initProductImageZoom = (slideActiveImage) => {
    if (window.innerWidth > 767) {
        var activeImage = slideActiveImage
        if (activeImage == undefined) {
            activeImage = document.getElementsByClassName('productImageSlide swiper-slide-active')[0]?.getElementsByTagName('img')[0];
            if (activeImage == undefined) {
                activeImage = document.getElementsByClassName('productImageSlide')[0]?.getElementsByTagName('img')[0];
            }
        }

        if (activeImage == undefined) {
            return;
        }

        let zoomUrl = activeImage.getAttribute("data-zoom-src");
        if (zoomUrl == undefined) {
            zoomUrl = activeImage.getAttribute("src");
        }

        // Both of these are item detail page furniture: the 40% image column the magnifier sizes
        // itself from, and the pane it paints into. A host that shows the slider without them -
        // the item selection popup, where a 320px thumbnail has no use for a 500px magnifier -
        // used to crash here on imageContainer.clientWidth, taking initSlider down with it.
        // Callers already cope with getting nothing back: productPageSlider guards this.zoom.
        var imageContainer = document.querySelector('#productImageContainer');
        var zoomTarget = document.getElementById('zoomImage');
        if (imageContainer == null || zoomTarget == null) {
            return;
        }

        return new ImageZoom(activeImage.parentElement, {
            width: imageContainer.clientWidth,
            height: imageContainer.clientWidth,
            zoomWidth: 500,
            zoomHeight: 500,
            img: zoomUrl,
            zoomedImg: zoomTarget
        });
    }
};

export default initProductImageZoom;